"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (Object.hasOwnProperty.call(mod, k)) result[k] = mod[k];
    result["default"] = mod;
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
var React = __importStar(require("react"));
var styles = __importStar(require("./PersonalInformationForm.module.css"));
var react_1 = require("react");
var Label_1 = require("components/Label");
var Input_1 = require("components/Input");
var findErrors_1 = require("lib/functions/findErrors");
var mobx_1 = require("mobx");
var mobx_react_1 = require("mobx-react");
var validations_1 = require("lib/functions/validations");
var CheckBox_1 = require("components/CheckBox");
var rules = {
    first_name: __assign(__assign({}, validations_1.mandatory), { format: {
            pattern: "[a-zA-Z-.' ]+",
            flags: "i",
            message: "can only contain characters, spaces, up quotes and dots",
            length: {
                minimum: 1,
                maximum: 20
            }
        } }),
    last_name: __assign(__assign({}, validations_1.mandatory), { format: {
            pattern: "[a-zA-Z-.' ]+",
            flags: "i",
            message: "can only contain characters, spaces, up quotes and dots",
            length: {
                minimum: 1,
                maximum: 30
            }
        } })
};
var middleNameRules = {
    middle_name: __assign(__assign({}, validations_1.mandatory), { format: {
            pattern: "[a-zA-Z-.' ]+",
            flags: "i",
            message: "can only contain characters, spaces, up quotes and dots",
            length: {
                minimum: 1,
                maximum: 20
            }
        } })
};
var PersonalInformationForm = (function (_super) {
    __extends(PersonalInformationForm, _super);
    function PersonalInformationForm(props) {
        var _this = _super.call(this, props) || this;
        _this.errors = {};
        _this.onChange = _this.onChange.bind(_this);
        _this.json_data = props.model.json_data;
        _this.onModel = _this.onModel.bind(_this);
        _this.isValid = _this.isValid.bind(_this);
        props.model.dispatcher.addListener(_this.onModel);
        return _this;
    }
    Object.defineProperty(PersonalInformationForm.prototype, "dataStore", {
        get: function () {
            return this.props.model.dataStore;
        },
        enumerable: true,
        configurable: true
    });
    PersonalInformationForm.prototype.onModel = function () {
        this.json_data = this.props.model.json_data;
        this.forceUpdate();
    };
    PersonalInformationForm.prototype.onChange = function (id, value) {
        return __awaiter(this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                console.log("Id", id);
                console.log("Value", value);
                this.json_data[id] = value;
                if (this.json_data.i_dont_have_middle_name &&
                    this.json_data.i_dont_have_middle_name === "yes") {
                    delete this.json_data.middle_name;
                }
                this.forceUpdate();
                return [2];
            });
        });
    };
    PersonalInformationForm.prototype.componentDidMount = function () {
        return __awaiter(this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                this.props.model.dispatcher.dispatch();
                this.props.model.addValidateFunction("PersonalInformationForm validateApplication", this.isValid);
                return [2];
            });
        });
    };
    PersonalInformationForm.prototype.componentWillUnmount = function () {
        return __awaiter(this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                this.props.model.removeValidateFunction("PersonalInformationForm validateApplication");
                this.props.model.dispatcher.removeListener(this.onModel);
                return [2];
            });
        });
    };
    PersonalInformationForm.prototype.isValid = function () {
        console.log("Validate PersonalInformationForm");
        var json_data = this.props.model.json_data;
        var specialRules = rules;
        if (!json_data.i_dont_have_middle_name || json_data.i_dont_have_middle_name === "no") {
            specialRules = __assign(__assign({}, specialRules), middleNameRules);
        }
        else {
            delete specialRules["middle_name"];
        }
        var _a = findErrors_1.findErrors(this.json_data, specialRules), isValid = _a.isValid, errors = _a.errors;
        this.errors = errors;
        console.log("Form errors", this.errors);
        return isValid;
    };
    PersonalInformationForm.prototype.render = function () {
        var model = this.props.model;
        var json_data = model.json_data;
        return (React.createElement("div", null,
            React.createElement("section", { className: "section-content scw" },
                React.createElement("h2", { className: "section-title-spa" }, "Provide your personal information"),
                React.createElement("article", null,
                    React.createElement("div", { className: "row" },
                        React.createElement("div", { className: "col-xs-12 col-md-12 space-bottom" },
                            React.createElement(Label_1.Label, { htmlFor: "first_name", text: "First Name", required: true }),
                            React.createElement(Input_1.Input, { id: "first_name", json_data: json_data, onChange: this.onChange, placeholder: "Enter your First Name", errors: this.errors })),
                        React.createElement("div", { className: "col-xs-12 col-md-12 space-bottom" },
                            React.createElement("div", { className: styles.divContainerTwo },
                                React.createElement("div", { className: "" + styles.columnTwo },
                                    React.createElement(CheckBox_1.CheckBox, { id: "i_dont_have_middle_name", json_data: json_data, onChange: this.onChange })),
                                React.createElement(Label_1.Label, { htmlFor: "i_dont_have_middle_name", text: "I don't have a Middle Name" }))),
                        React.createElement("div", { className: "col-xs-12 col-md-12 space-bottom" },
                            React.createElement(Label_1.Label, { htmlFor: "middle_name", text: "Middle Name", required: !json_data.i_dont_have_middle_name ||
                                    json_data.i_dont_have_middle_name === "no" }),
                            React.createElement(Input_1.Input, { id: "middle_name", json_data: json_data, onChange: this.onChange, placeholder: "Enter your Middle Name", errors: this.errors })),
                        React.createElement("div", { className: "col-xs-12 col-md-12 space-bottom" },
                            React.createElement(Label_1.Label, { htmlFor: "last_name", text: "Last Name", required: true }),
                            React.createElement(Input_1.Input, { id: "last_name", json_data: json_data, onChange: this.onChange, placeholder: "Enter your Last Name", errors: this.errors })))))));
    };
    __decorate([
        mobx_1.observable
    ], PersonalInformationForm.prototype, "errors", void 0);
    PersonalInformationForm = __decorate([
        mobx_react_1.observer
    ], PersonalInformationForm);
    return PersonalInformationForm;
}(react_1.Component));
exports.PersonalInformationForm = PersonalInformationForm;
//# sourceMappingURL=data:application/json;base64,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